'use strict';
// `SameValueZero` abstract operation
// https://tc39.es/ecma262/#sec-samevaluezero
module.exports = function (x, y) {
  // eslint-disable-next-line no-self-compare -- NaN check
  return x === y || x !== x && y !== y;
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/same-value-zero.js
// module id = 1257
// module chunks = 0